import { render, staticRenderFns } from "./TextLeftNavigation.vue?vue&type=template&id=280da00c&scoped=true&"
import script from "./TextLeftNavigation.vue?vue&type=script&lang=js&"
export * from "./TextLeftNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TextLeftNavigation.vue?vue&type=style&index=0&id=280da00c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280da00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VList,VListItem,VListItemTitle,VSheet})
